import { render, staticRenderFns } from "./ColorTable.vue?vue&type=template&id=50db7040&"
import script from "./ColorTable.vue?vue&type=script&lang=js&"
export * from "./ColorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports